import React from 'react';

const {
    Provider: NewsServiceProvider,
    Counsumer: NewsServiceConsumer
} = React.createContext();


export {NewsServiceProvider, NewsServiceConsumer};
